import React, { createContext, useState, useEffect } from 'react';
import {
  getAuth,
  signInWithCustomToken,
  signOut,
  onAuthStateChanged,
  updateProfile,
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { msalInstance, powerbiScopes } from './authService';

const firebaseConfig = {
  apiKey: "AIzaSyAiybtsgv5JJ2N8s9w8si_z-yF-xvD9ot4",
  authDomain: "goes-legal-matrix-web.firebaseapp.com",
  projectId: "goes-legal-matrix-web",
  storageBucket: "goes-legal-matrix-web.firebasestorage.app",
  messagingSenderId: "361431423668",
  appId: "1:361431423668:web:45e6816ff2f6010c44d5e1",
  measurementId: "G-20T2DVKNFE"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export const AuthContext = createContext();
let msalInitializedAuthContext = false;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [firebaseUid, setFirebaseUid] = useState(null);
  const [loading, setLoading] = useState(true);

  const loginWithGoogle = async () => {
    try {
      const auth = getAuth();
      const provider = new GoogleAuthProvider();

      provider.setCustomParameters({
        prompt: "select_account"
      });

      const result = await signInWithPopup(auth, provider);

      console.log("✅ Google login OK:", result.user.uid);

      setUser({
        provider: "google",
        email: result.user.email,
        name: result.user.displayName
      });

    } catch (error) {
      console.error("❌ Error Google login:", error);
      throw error;
    }
  };

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        if (!msalInitializedAuthContext) {
          await msalInstance.initialize();
          msalInitializedAuthContext = true;
        }

        const redirectResponse = await msalInstance.handleRedirectPromise();
        let account = null;

        if (redirectResponse) {
          account = redirectResponse.account;
          setUser({
            provider: 'microsoft',
            email: account.username,
            name: account.name,
            raw: account,
          });
          msalInstance.setActiveAccount(account);
        } else {
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length > 0) {
            account = accounts[0];
            msalInstance.setActiveAccount(account);
          }
        }

        setUser(
          account
            ? {
              provider: 'microsoft',
              email: account.username,
              name: account.name,
              raw: account,
            }
            : null
        );

        if (account) {
          await loginToFirebaseWithMsal(account);
        }

      } catch (err) {
        console.error('Error inicializando auth:', err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    initializeAuth();

    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setFirebaseUid(firebaseUser ? firebaseUser.uid : null);
      console.log('[AuthContext] Firebase UID:', firebaseUser?.uid);
    });

    return () => unsubscribe();
  }, []);

  const loginWithMicrosoft = async () => {
    try {
      await msalInstance.loginRedirect({
        scopes: ["openid", "profile", "email", ...powerbiScopes]
      });
    } catch (error) {
      console.error('Error en login:', error);
      throw error;
    }
  };

  const loginToFirebaseWithMsal = async (account) => {
    try {
      const auth = getAuth();

      if (auth.currentUser) {
        await signOut(auth);
      }

      const response = await msalInstance.acquireTokenSilent({
        scopes: ["openid", "profile", "email"],
        account: account
      });

      const res = await fetch("https://us-central1-goes-legal-matrix-web.cloudfunctions.net/firebaseAuth", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idToken: response.idToken })
      });

      const data = await res.json();

      await signInWithCustomToken(auth, data.firebaseToken);

      // 👇 Actualizar perfil en Firebase con datos de MSAL
      if (auth.currentUser) {
        await updateProfile(auth.currentUser, {
          displayName: account?.username || account?.name || "Usuario Microsoft"
        });
        console.log("✅ Perfil actualizado en Firebase:", auth.currentUser.displayName);
      }

      console.log("🔥 Firebase SSO OK:", auth.currentUser?.uid);

    } catch (error) {
      console.error("❌ Error Firebase SSO:", error);
    }
  };

  const logout = async () => {
    try {
      const auth = getAuth();

      if (auth.currentUser) {
        await signOut(auth);
      }

      const activeAccount = msalInstance.getActiveAccount();

      if (activeAccount) {
        await msalInstance.logoutRedirect({
          postLogoutRedirectUri: '/'
        });
        return;
      }

      setUser(null);
      setFirebaseUid(null);

    } catch (error) {
      console.error('Error en logout:', error);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        firebaseUid,
        loginWithMicrosoft,
        loginWithGoogle,
        logout,
        loading,
        db
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};